import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ContainerDimensions from "react-container-dimensions";
import BacktestService from "../../../service/backtest.service";
// import Knob from "../../common/knob";
import Donut from "../../common/Donut";
import Cards from "../../myPortfolios/cards/cards";
import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import CommonButton from "../../common/commonButton";

import AtRetirement from "./atRetirement";
import GroupStackedBar from "../../d3Components/StackedBarChart/group_stackedBar";

import AccumulationHelper from "./accumulation.helper";
import DecumulationHelper from "./RIGEquation.helper";

import moneyFormatter from "../../common/moneyFormatter.js";
import "./rig.scss";

const { Slider } = window;

class RIGEquation extends Component {
  incomeSourceRanges = [];
  state = {
    liveData: [],
    currentAgeList: [],
    analyze: false,
    groupStackedBarChartData: [],
    lineChartData: [],
    investmentSource: 0,
    state_donutVal: 2
  };

  ranges = [];

  handleChange = (newValue, id) => {
    const { knobHandler } = this.props;
    switch (id) {
      case "age":
        knobHandler("age", newValue);
        break;
      case "savings":
        knobHandler("savings", newValue);
        this.computeAddedIncome(newValue, this.props.rate);
        // setTimeout(() => this.computeShortFall(this.props), 0);
        break;
      case "income":
        knobHandler("income", newValue);
        setTimeout(() => this.computeShortFall(this.props), 0);
        break;
      case "withdraw":
        knobHandler("withdraw", newValue);
        setTimeout(() => this.computeShortFall(this.props), 0);
        break;
      case "retirementAccount":
        knobHandler("retirementAccount", newValue);
        setTimeout(() => this.computeShortFall(this.props), 0);
        break;
      default:
    }
  };

  computeAddedIncome(savings = null, rate = null) {
    const { donutHandler } = this.props;
    if (!rate) {
      rate = this.props.rate;
    }
    if (!savings) {
      savings = this.props.savings / 1000;
    }
    var addIncome = Math.round((rate * savings) / 1000 / 1000);
    donutHandler("otherIncome", addIncome);
    this.computeShortFall(addIncome, this.props);
  }

  setFundType = e => {
    const { donutHandler, fundNameHandler, savings } = this.props;
    let value = e.currentTarget.value * 1;

    donutHandler("rate", +value.toFixed(2));
    fundNameHandler("id", e.target.getAttribute("id") * 1);
    this.computeAddedIncome(savings / 1000, value);
    this.updateInvestmentSource(this.props);
  };

  // donut shortfall calculation
  computeShortFall({ otherIncome = 0, ...props }) {
    const { withdraw, dec_otherIncome, rate, savings, donutHandler } = props;
    // const { donutHandler } = this.props;
    const { lineChartData } = this.state;
    if (savings) {
      if (!otherIncome) {
        otherIncome = dec_otherIncome;
      }

      let investmentSource = (savings * (rate / 100)).toFixed() * 1;
      this.setState({ investmentSource });

      // var sf = +(
      //   withdraw -
      //   dec_otherIncome -
      //   dec_socialSecurity -
      //   investmentSource
      // ).toFixed();

      var sf = savings / 20;
      if (sf < 0) sf = 0;
      var sfpercent = Math.round((sf / withdraw) * 100);
      console.log(sf, sfpercent, props);
      // donutHandler("donutVal", 100 - sfpercent);
      // donutHandler("shortfall", sf);

      // -------- new short fall calc --------------
      console.log(lineChartData, "line chart data from rig eq");
      let range_Depletion_Annually;
      if (lineChartData.length > 0) {
        const getMinAndMaxDifference = data => {
          let arr = [];
          for (let i = 0; i < data.length; i++) {
            if (i > 0) {
              let initial = data[i]["Savings"];
              let prev = data[i - 1]["Savings"];
              let value = prev - initial;
              arr.push(value);
            }
          }

          let total = arr.reduce((a, b) => a + b, 0);
          let nonZero = arr.filter(el => el !== 0);

          let lastNumber;
          if (
            Math.round(nonZero[nonZero.length - 1]) <
            Math.round(nonZero[nonZero.length - 2])
          ) {
            lastNumber = Math.ceil(nonZero[nonZero.length - 2]);
          } else {
            lastNumber = Math.ceil(nonZero[nonZero.length - 1]);
          }
          return [Math.round(nonZero[0]), lastNumber, total];
        };
        let compute = getMinAndMaxDifference(lineChartData);
        range_Depletion_Annually =
          Number.isNaN(compute[0]) && Number.isNaN(compute[1])
            ? 0
            : `${Math.floor(
                isNaN(compute[0]) ? 0 : compute[0] / 1000
              )}-${Math.round(isNaN(compute[1]) ? 0 : compute[1] / 1000)}`;

        let average = compute[2] / lineChartData.length;
        let percentage = (average / withdraw) * 100;
        console.log(
          average,
          percentage,
          "-----average and percent RIGEquation----"
        );
        // excess
        var ex = sf / 1000;
        donutHandler("excess", ex);

        donutHandler("donutVal", percentage);
        donutHandler("rangetext", range_Depletion_Annually);
      }
    }
  }

  componentWillMount() {
    // Decumulation directing to analyze step
    if (this.props.selectedPlan === "accumulation") {
      this.props.analyzeButtonClickCount("analizeButtonClicked", 1);
      this.setState({
        analyze: true
      });
    }
    // set select option data
    let ags = AccumulationHelper.dropDown_AGE(60, 75);
    this.setState({
      currentAgeList: ags
    });
  }
  async componentDidMount() {
    // render ranges
    setTimeout(() => this.renderRange(), 0);

    // group barchart data
    this.groupStackedBar(this.props);

    this.computeShortFall(this.props);
    await BacktestService.getScenariosNew("LIVE").then(res => {
      let live = [
        {
          benchmark_name: "Benchmark: Capital Protection Benchmark",
          bm_annualized_return: 0.022,
          fund_annualized_return: 0.022,
          scenario_id: 999,
          type: "LIVE"
        }
      ];

      for (var i in res) {
        var obj = {};
        obj["scenario_id"] = res[i]["scenario_id"];
        obj["type"] = res[i]["type"];
        obj["bm_annualized_return"] = res[i]["bm_annualized_return"];
        obj["fund_annualized_return"] = res[i]["fund_annualized_return"];
        obj["scenario_name"] = res[i]["scenario_name"];
        obj["alpha"] = res[i]["alpha"];
        obj["beta"] = res[i]["beta"];
        obj["sortino_ratio"] = res[i]["sortino_ratio"];
        obj["benchmark_name"] = res[i]["benchmark_name"];
        obj["benchmark"] = res[i]["benchmark"];
        obj["scn_status"] = res[i]["scn_status"].toUpperCase();
        live.push(obj);
      }
      this.setState({
        liveData: live
      });
    });

    setTimeout(() => this.IncomeSourceSlider(), 0);
    this.updateInvestmentSource(this.props);

    // setting default selected to 2.2/ 999
    // this.props.donutHandler("rate", 2.2);
    // this.props.fundNameHandler("id", 999);
  }

  componentWillReceiveProps(nextProps) {
    const {
      currentSavings,
      possibleAnnualSavings,
      retirementAge,
      currentAge,
      rate
    } = nextProps;
    // render ranges
    setTimeout(() => this.renderRange(), 0);

    // group barchart data
    this.groupStackedBar(nextProps);

    setTimeout(() => this.IncomeSourceSlider(), 0);

    // donut handler
    setTimeout(() => this.computeShortFall(nextProps), 0);

    if (
      currentSavings !== this.props.currentSavings ||
      possibleAnnualSavings !== this.props.possibleAnnualSavings ||
      retirementAge !== this.props.retirementAge ||
      currentAge !== this.props.currentAge ||
      rate !== this.props.rate
    ) {
      this.updateInvestmentSource(nextProps);
    }
  }

  renderRange = () => {
    const { savings, withdraw, retirementAccount } = this.props;
    const currentSaving_op1 = {
      // formatter: value => `${value}$`,
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 10,
      min: 0,
      max: 5000000,
      id: id => id
    };
    const retirementNeed_op3 = {
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 5,
      min: 0,
      max: 150000,
      id: id => id
    };

    // clearing previous slider dom
    if (this.ranges.length) {
      this.ranges.forEach(fn => {
        fn.destroy();
      });
      this.ranges = [];
    }
    var _current = new Slider(`#savings`, {
      ...currentSaving_op1,
      value: +savings,
      id: "savings"
    });
    var _expected = new Slider(`#withdraw`, {
      ...retirementNeed_op3,
      value: +withdraw,
      id: "withdraw"
    });

    var _retirementAccount = new Slider(`#retirementAccount`, {
      ...currentSaving_op1,
      value: +retirementAccount,
      id: "retirementAccount"
    });

    this.ranges.push(_current, _expected, _retirementAccount);
  };

  onSliderChange = id => {
    const range = this.ranges;
    const filteredRange = range.filter(d => d.options.id === id);
    if (filteredRange[0]["options"]["id"] === id) {
      let value = filteredRange[0]["_state"]["value"][0] * 1;

      this.handleChange(value, id);
    }
  };

  // income source handler
  sourceHandler = e => {
    this.updateInvestmentSource(this.props);

    this.props.setSOURCE(e.target.name, e.target.value);
    this.props.setDecumulationIncomeSource(e.target.name, e.target.value);
  };
  // investment source update
  updateInvestmentSource = ({
    currentSavings,
    possibleAnnualSavings,
    retirementAge,
    currentAge,
    rate
  }) => {
    var investmentSoure = (
      AccumulationHelper.estimatedSavings(
        currentSavings,
        possibleAnnualSavings,
        rate,
        retirementAge * 1 - currentAge * 1
      ) *
      (rate / 100)
    ).toFixed();
    this.props.setSOURCE("investmentSource", investmentSoure * 1);
  };
  handleAnalyzeButton = () => {
    let val = +(this.props.analizeButtonClicked + 1);
    this.props.analyzeButtonClickCount("analizeButtonClicked", val);

    if (this.props.analizeButtonClicked <= 1) {
      this.setState({ analyze: true });
    }
  };

  // group stack bar chart data
  groupStackedBar = props => {
    const {
      savings,
      withdraw,
      dec_socialSecurity,
      dec_otherIncome,
      dec_investmentSource,
      retirementAccount,
      age,
      rate
    } = props;

    const Data = DecumulationHelper.Data({
      savings,
      withdraw,
      dec_socialSecurity,
      dec_otherIncome,
      dec_investmentSource,
      retirementAccount,
      age,
      rate
    });
    this.setState({
      groupStackedBarChartData: Data[0],
      lineChartData: Data[1]
    });
    this.props.knobHandler("dec_barchartData", Data[2]);

    this.props.setPDFTableData(Data[3]);
  };
  // income source sliders
  IncomeSourceSlider = () => {
    const { dec_socialSecurity, dec_otherIncome } = this.props;
    const op1 = {
      // formatter: value => `${value}$`,
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    // clear prev slider
    if (this.incomeSourceRanges.length) {
      this.incomeSourceRanges.forEach(fn => {
        fn.destroy();
      });
      this.incomeSourceRanges = [];
    }

    var social = new Slider(`#dec_socialSecurity`, {
      ...op1,
      value: +dec_socialSecurity,
      id: "dec_socialSecurity"
    });
    var possible = new Slider(`#dec_otherIncome`, {
      ...op1,
      value: +dec_otherIncome,
      id: "dec_otherIncome"
    });
    this.incomeSourceRanges.push(social, possible);
  };

  sourceSliderHandler = id => {
    const filteredRange = this.incomeSourceRanges.filter(
      d => d.options.id === id
    );
    if (filteredRange[0]["options"]["id"] === id) {
      let value = filteredRange[0]["_state"]["value"][0];

      this.props.setSOURCE(id, value);
      this.props.setDecumulationIncomeSource(id, value);
    }
  };

  render() {
    const {
      liveData,
      currentAgeList,
      analyze,
      groupStackedBarChartData,
      lineChartData
    } = this.state;
    const {
      age,
      savings,
      withdraw,
      donutVal,
      retirementAccount,
      id,
      fundName,
      dec_socialSecurity,
      dec_otherIncome,
      analizeButtonClicked
    } = this.props;

    return (
      <div className="page-body">
        <div className="step clearfix">
          {analizeButtonClicked === 0 ? (
            <div className="accumulation_header">
              <div>
                <b>ABOUT CLIENT :</b>
              </div>
            </div>
          ) : (
            <div
              className="accumulation_header"
              onClick={() => {
                this.setState({
                  analyze: !this.state.analyze
                });
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="accumulation_header_content">
                <div>Age - {age} YRS</div>
                <div>Savings - {moneyFormatter(savings)}</div>
                <div>
                  Retirement Accounts - {moneyFormatter(retirementAccount)}
                </div>
                <div>Retirement Income Needed - {moneyFormatter(withdraw)}</div>
              </div>
              <i
                className={`fa fa-2x bounce ${
                  !this.state.analyze
                    ? `fa-angle-double-up`
                    : `fa-angle-double-down`
                } `}
              ></i>
            </div>
          )}
          <div className="accumulation_container">
            {/* <table className="knobsTable">
          <thead>
            <tr>
              <th>CURRENT AGE</th>
              <th>CURRENT SAVINGS</th>
              <th>
                INCOME FROM SOCIAL SECURITY <br></br>&amp; OTHER SOURCES
              </th>
              <th>
                EXPECTED ANNUAL <br></br>RETIREMENT NEED
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Knob
                  id="age"
                  size={50}
                  numTicks={40}
                  degrees={260}
                  min={30}
                  max={70}
                  value={60}
                  color={true}
                  onChange={this.handleChange}
                  display="inline-block"
                />
                <span className="dialValue">{age}</span>
                <span>yrs</span>
              </td>

              <td>
                <Knob
                  id="savings"
                  size={50}
                  numTicks={180}
                  degrees={260}
                  min={100}
                  max={5000}
                  value={1000}
                  color={true}
                  onChange={this.handleChange}
                  display="inline-block"
                />
                <span className="dialValue">{savings}</span>
                <span>k</span>
              </td>
              <td>
                <Knob
                  id="income"
                  size={50}
                  numTicks={90}
                  degrees={260}
                  min={10}
                  max={100}
                  value={20}
                  color={true}
                  onChange={this.handleChange}
                  display="inline-block"
                />
                <span className="dialValue">{income}</span>
                <span>k</span>
              </td>
              <td>
                <Knob
                  id="withdraw"
                  size={50}
                  numTicks={100}
                  degrees={260}
                  min={50}
                  max={150}
                  value={100}
                  color={true}
                  onChange={this.handleChange}
                  display="inline-block"
                />
                <span className="dialValue">{withdraw}</span>
                <span>k</span>
              </td>
            </tr>
          </tbody>
        </table> */}

            <div
              style={{
                display: analyze === false ? "block" : "none"
              }}
            >
              <div className="row">
                <div className="col-md-3 my-auto">
                  <div className="accumulation_card">
                    <h4 style={{ fontWeight: "bold" }}>
                      CURRENT AGE OF CLIENT
                    </h4>
                    <div className="custom-select" style={{ width: "80%" }}>
                      <select
                        className="form-control"
                        onChange={e =>
                          this.handleChange(e.target.value * 1, "age")
                        }
                        value={age}
                      >
                        {currentAgeList.map((e, i) => (
                          <option value={e} key={i}>
                            {e}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 my-auto">
                  <div className="accumulation_card">
                    <h4 style={{ fontWeight: "bold" }}>
                      LIQUID ASSETS (Savings/Brokerage)
                    </h4>
                    <div className="txt">{(savings / 1000).toFixed(2)}K</div>
                    <input
                      type="number"
                      placeholder="$100000"
                      min="0"
                      value={savings}
                      className="acc_input"
                      name="savings"
                      onChange={e =>
                        this.handleChange(e.target.value * 1, "savings")
                      }
                    />
                    <div
                      onClick={() => {
                        this.onSliderChange("savings");
                      }}
                    >
                      <div id={`savings`} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 my-auto">
                  <div className="accumulation_card">
                    <h4 style={{ fontWeight: "bold" }}>
                      RETIREMENT ACCOUNTS (IRA/401K)
                    </h4>
                    <div className="txt">{retirementAccount / 1000}K</div>
                    <input
                      type="number"
                      placeholder="$100000"
                      min="0"
                      value={retirementAccount}
                      className="acc_input"
                      name="retirementAccount"
                      onChange={e =>
                        this.handleChange(
                          e.target.value * 1,
                          "retirementAccount"
                        )
                      }
                    />
                    <div
                      onClick={() => {
                        this.onSliderChange("retirementAccount");
                      }}
                    >
                      <div id={`retirementAccount`} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 my-auto">
                  <div className="accumulation_card">
                    <h4 style={{ fontWeight: "bold" }}>
                      EXPECTED ANNUAL RETIREMENT NEED
                    </h4>
                    <div className="txt">{withdraw / 1000}K</div>
                    <input
                      type="number"
                      placeholder="$100000"
                      min="0"
                      value={withdraw}
                      className="acc_input"
                      name="withdraw"
                      onChange={e =>
                        this.handleChange(e.target.value * 1, "withdraw")
                      }
                    />
                    <div
                      onClick={() => {
                        this.onSliderChange("withdraw");
                      }}
                    >
                      <div id={`withdraw`} />
                    </div>
                  </div>
                </div>
              </div>
              {analizeButtonClicked === 0 ? (
                <div style={{ display: "flex" }}>
                  <CommonButton
                    onClick={this.handleAnalyzeButton}
                    style={{ marginLeft: "auto" }}
                  >
                    Analyze
                  </CommonButton>
                </div>
              ) : null}
            </div>

            <div
              style={{
                display: analizeButtonClicked >= 1 ? "block" : "none"
              }}
            >
              <div className="donut-container col-md-4 my-auto">
                <Donut
                  value={this.props.donutVal}
                  valuelabel={"DEPLETION"}
                  shortfall={this.props.rangetext}
                  // shortfall={+(this.props.shortfall / 1000).toFixed(2)}
                />
                <div style={{ paddingTop: "10px" }}>
                  (Annual Savings Depletion)
                </div>
              </div>

              <div className="col-md-8 my-auto">
                {groupStackedBarChartData.length > 0 ? (
                  <ContainerDimensions>
                    {({ width }) => (
                      <Fragment>
                        {width > 0 ? (
                          <GroupStackedBar
                            id="decumulation-groupbar"
                            width={width}
                            height="400"
                            data={groupStackedBarChartData}
                            lineChartData={lineChartData}
                          />
                        ) : null}
                      </Fragment>
                    )}
                  </ContainerDimensions>
                ) : null}
              </div>

              <div>
                <div className="col-md-12 incomeSource-parent">
                  <div className="col-md-2 align-middle">
                    <h4 style={{ fontWeight: "bold" }}>INCOME SOURCE</h4>
                  </div>
                  <div className="col-md-10" style={{ display: "flex" }}>
                    <div className="col-md-4 my-auto">
                      <div className="accumulation_card">
                        <h4 style={{ fontWeight: "bold" }}> Social Security</h4>
                        <input
                          type="number"
                          placeholder="$20000"
                          min="0"
                          max="1000000"
                          value={dec_socialSecurity}
                          className="acc_input"
                          name="dec_socialSecurity"
                          onChange={this.sourceHandler}
                        />

                        <div
                          onClick={() => {
                            this.sourceSliderHandler("dec_socialSecurity");
                          }}
                        >
                          <div id={`dec_socialSecurity`} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 my-auto">
                      <div className="accumulation_card">
                        <h4 style={{ fontWeight: "bold" }}>Other Income</h4>
                        <input
                          type="number"
                          placeholder="$10000"
                          min="0"
                          max="1000000"
                          value={dec_otherIncome}
                          className="acc_input"
                          name="dec_otherIncome"
                          onChange={this.sourceHandler}
                        />
                        <div
                          onClick={() => {
                            this.sourceSliderHandler("dec_otherIncome");
                          }}
                        >
                          <div id={`dec_otherIncome`} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 my-auto">
                      <div
                        className="accumulation_card"
                        style={{
                          textAlign: "center"
                        }}
                      >
                        <h4 style={{ fontWeight: "bold" }}>
                          Investment Sources
                        </h4>
                        <h3
                          style={{
                            fontWeight: "bold"
                          }}
                        >
                          {moneyFormatter(this.state.investmentSource)}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <table className="fundTypeTable">
                <thead>
                  <tr>
                    {liveData
                      .filter(
                        e =>
                          e.scenario_id === 706 ||
                          e.scenario_id === 707 ||
                          e.scenario_id === 999
                      )
                      .map((d, i) => {
                        return (
                          <th key={i}>
                            <input
                              type="radio"
                              name={
                                d.scenario_id === 999
                                  ? " TYPICAL CAPITAL PROTECTION FUND"
                                  : d.scenario_id === 706
                                  ? " IQCIO CONSERVATIVE FUND"
                                  : " IQCIO MODERATE FUND"
                              }
                              value={d.fund_annualized_return * 100}
                              id={d.scenario_id}
                              checked={id === d.scenario_id ? "checked" : ""}
                              onChange={this.setFundType}
                            />
                            {d.scenario_id === 999
                              ? " TYPICAL CAPITAL PROTECTION FUND"
                              : d.scenario_id === 706
                              ? " IQCIO CONSERVATIVE FUND"
                              : " IQCIO MODERATE FUND"}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {liveData.length ? (
                    <tr>
                      <Fragment>
                        {liveData
                          .filter(
                            e =>
                              e.scenario_id === 706 ||
                              e.scenario_id === 707 ||
                              e.scenario_id === 999
                          )
                          .map((portfolio, i) => {
                            return (
                              <td key={i}>
                                <Cards
                                  key={i}
                                  data={portfolio}
                                  keyData={i}
                                  link={false}
                                  heading={false}
                                  footer={false}
                                  border={false}
                                />
                              </td>
                            );
                          })}
                      </Fragment>
                    </tr>
                  ) : (
                    <tr>
                      <td style={{ padding: "10px 0px" }}>
                        <Spinner />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <AtRetirement selectedFundName={fundName} id={id * 1} />
              <div className="btn-group">
                <button
                  className="btn btn-next"
                  onClick={() => this.props.navToNextPage()}
                  disabled={id === 0}
                >
                  Next <i className="fa fa-angle-right" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  ({
    retirement: {
      rig: {
        intro: { selectedPlan },
        equation: {
          age,
          savings,
          income,
          withdraw,
          retirementAccount,
          donut: { donutVal, otherIncome, shortfall, rate, rangetext },
          fundSelected: { fundName, id },
          dec_socialSecurity,
          dec_otherIncome,
          dec_investmentSource,
          analizeButtonClicked
        },
        accumulation: {
          currentAge,
          retirementAge,
          currentSavings,
          possibleAnnualSavings,
          annualIncomeNeeded,
          socialSecurity,
          investmentSource,
          acc_otherIncome
        }
      }
    }
  }) => ({
    selectedPlan,
    age,
    savings,
    income,
    withdraw,
    retirementAccount,
    donutVal,
    otherIncome,
    shortfall,
    rate,
    rangetext,
    id,
    fundName,
    dec_socialSecurity,
    dec_otherIncome,
    dec_investmentSource,
    // selectedPortfolio
    currentAge,
    retirementAge,
    currentSavings,
    possibleAnnualSavings,
    annualIncomeNeeded,
    socialSecurity,
    investmentSource,
    acc_otherIncome,
    analizeButtonClicked
  }),
  dispatch => ({
    knobHandler: (name, value) =>
      dispatch({ type: "RETIREMENT_KNOB_HANDLER", payload: { name, value } }),
    donutHandler: (name, value) =>
      dispatch({ type: "RETIREMENT_DONUT_HANDLER", payload: { name, value } }),
    fundNameHandler: (name, value) =>
      dispatch({ type: "RETIREMENT_SELECTED_FUND", payload: { name, value } }),
    setSOURCE: (name, value) =>
      dispatch({ type: "ACCUMULATION_SET_SOURCE", payload: { name, value } }),
    // use to set decumulation slider val --
    setDecumulationIncomeSource: (name, value) =>
      dispatch({
        type: "DECUMULATION_SET_INCOME_SOURCE",
        payload: { name, value }
      }),
    analyzeButtonClickCount: (name, value) =>
      dispatch({
        type: "RETIREMENT_ANALYZE_HANDLER",
        payload: { name, value }
      }),
    setPDFTableData: value =>
      dispatch({ type: "RETIREMENT_PDF_TABLE", payload: value })
  })
)(RIGEquation);



// WEBPACK FOOTER //
// ./src/components/pages/Retire/RIGEquation.jsx